import type IChaynsLogger from '../types/IChaynsLogger';
import type { LoggerConfig } from '../types/LoggerConfig';
import type { LogErrorObject } from '../types/LogErrorObject';
import type { LogObject } from '../types/LogObject';
import { init } from '../core/init';
import { critical, debug, error, info, warning } from '../logging';
import { set as setDefaults } from '../core/defaults';

export default class ChaynsLogger implements IChaynsLogger {
    readonly #applicationUid: string;

    constructor(config: LoggerConfig) {
        init(config);

        this.#applicationUid = config.applicationUid;
    }

    get applicationUid(): string {
        return this.#applicationUid;
    }

    /**
     * Sets default values which should be send on each log
     * @param defaults
     */
    setDefaults(defaults?: { [key: string]: any }): void {
        setDefaults(defaults, this.#applicationUid);
    }

    /**
     * Sends a debug log.
     * @param logObject
     */
    debug(logObject: LogObject): void {
        debug(logObject, this.#applicationUid);
    }

    /**
     * Sends an info log.
     * @param logObject
     */
    info(logObject: LogObject): void {
        info(logObject, this.#applicationUid);
    }

    /**
     * Sends a warning log.
     * @param logObject
     * @param err
     */
    warning(logObject: LogErrorObject, err?: Error): void {
        warning(logObject, err, this.#applicationUid);
    }

    /**
     * Sends an error log.
     * @param logObject
     * @param err
     */
    error(logObject: LogErrorObject, err?: Error): void {
        error(logObject, err, this.#applicationUid);
    }

    /**
     * Sends a critical log.
     * @param logObject
     * @param err
     */
    critical(logObject: LogErrorObject, err?: Error): void {
        critical(logObject, err, this.#applicationUid);
    }
}
